/* eslint-disable react-hooks/exhaustive-deps */
import TabNav from "components/TabNav";
import { useTranslation } from "contexts/i18nContext";
import { useHasRole } from "contexts/AuthContext";
import AddAppealCouncilLitigationDecisionModal from "pages/advocateAppealRequests/fragments/AddAppealCouncilLitigationDecisionModal";
import AddAppealLitigationDecisionModal from "pages/advocateAppealRequests/fragments/AddAppealLitigationDecisionModal";
import AppealCouncilLitigationCard from "pages/advocateAppealRequests/fragments/AppealCouncilLitigationCard";
import AppealLitigationCard from "pages/advocateAppealRequests/fragments/AppealLitigationCard";
import TerminateAppealLitigationModal from "pages/advocateAppealRequests/fragments/TerminateAppealLitigationModal";
import AddAccusedSummonModal from "pages/advocateComplaint/fragments/AddAccusedSummonModal";
import ChargeDocumentCard from "pages/advocateComplaint/fragments/ChargeDocumentCard";
import ComplaintDetailInfoCard from "pages/advocateComplaint/fragments/ComplaintDetailInfoCard";
import DecisionCard from "pages/advocateComplaint/fragments/DecisionCard";
import ListEvidenceCard from "pages/advocateComplaint/fragments/ListEvidenceCard";
import ListReporterCard from "pages/advocateComplaint/fragments/ListReporterCard";
import ListVictimCard from "pages/advocateComplaint/fragments/ListVictimCard";
import ListWitnessCard from "pages/advocateComplaint/fragments/ListWitnessCard";
import { useCallback, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import {
  fetchAccusedSummonByComplaintId,
  fetchAdvocateComplaintById,
  fetchAppealCouncilLitigationByAppealSummonId,
  fetchAppealLitigationByAppealSummonId,
  fetchCourtAppealByComplaintId,
  fetchInvestigationByComplaintId,
} from "services/advocateComplaintService";
import {
  AccusedSummon,
  AdvocateComplaints,
  CouncilLitigation,
  CourtAppeal,
  Investigation,
  Litigation,
} from "types";
import {
  ACCUSED_COMPLAINT_STATUS,
  COMPLIANT_STATUS,
  INVESTIGATION_STATUS,
} from "utils/constantValues";
import { ADVOCATE_ROLES, ROLES } from "utils/roles";
import AccusedSummonCard from "./fragments/AccusedSummonCard";
import AddAccusedDailyHearingModal from "./fragments/AddAccusedDailyHearingModal";
import AppealToCourtModal from "./fragments/AppealToCourtModal";

export default function SingleAdvocateAccusedForZonal() {
  const { uu_id } = useParams();
  const { t } = useTranslation();

  const canViewCompliantDetail = useHasRole([
    ADVOCATE_ROLES.INSPECTION_PROSECUTOR,
    ADVOCATE_ROLES.INSPECTION_COORDINATOR,
    ADVOCATE_ROLES.INSPECTION_DIRECTOR,
  ]);
  const canViewAppealLitigationCard = useHasRole([
    ADVOCATE_ROLES.INSPECTION_PROSECUTOR,
    ADVOCATE_ROLES.INSPECTION_COORDINATOR,
    ADVOCATE_ROLES.INSPECTION_DIRECTOR,
  ]);
  const canViewChargeDoc = useHasRole([
    ADVOCATE_ROLES.INSPECTION_COORDINATOR,
    ADVOCATE_ROLES.INSPECTION_DIRECTOR,
    ADVOCATE_ROLES.INSPECTION_PROSECUTOR,
    ADVOCATE_ROLES.INSPECTION_REGISTRAR,
    ROLES.INSPECTION_REGISTRAR,
  ]);
  const canViewAccusedSummon = useHasRole([
    ADVOCATE_ROLES.INSPECTION_COORDINATOR,
    ADVOCATE_ROLES.INSPECTION_DIRECTOR,
    ADVOCATE_ROLES.INSPECTION_PROSECUTOR,
    ADVOCATE_ROLES.INSPECTION_REGISTRAR,
    ROLES.INSPECTION_REGISTRAR,

    ADVOCATE_ROLES.ZONAL_COUNCIL_OFFICE_HEAD,
    ADVOCATE_ROLES.REGIONAL_COUNCIL_OFFICE_HEAD,
    ADVOCATE_ROLES.ZONAL_COUNCIL_OFFICE_WRITER,
    ADVOCATE_ROLES.REGIONAL_COUNCIL_OFFICE_WRITER,
    ADVOCATE_ROLES.ZONAL_OFFICE_OF_COUNCIL_COORDINATOR,
    ADVOCATE_ROLES.ZONAL_COUNCIL_OFFICE_WRITER,
  ]);

  const canCreateInspectionDailyHearing = useHasRole([
    ADVOCATE_ROLES.INSPECTION_PROSECUTOR,
  ]);
  const canCreateCouncilDailyHearing = useHasRole([
    ADVOCATE_ROLES.ZONAL_COUNCIL_OFFICE_HEAD,
    ADVOCATE_ROLES.REGIONAL_COUNCIL_OFFICE_HEAD,
  ]);
  const canCreateCouncilDailyHearingForWritter = useHasRole([
    ADVOCATE_ROLES.ZONAL_COUNCIL_OFFICE_WRITER,
    ADVOCATE_ROLES.REGIONAL_COUNCIL_OFFICE_WRITER,
  ]);
  const canCreateLitigationDecision = useHasRole([
    ADVOCATE_ROLES.INSPECTION_PROSECUTOR,
  ]);
  const canCreateCouncilLitigationDecision = useHasRole([
    ADVOCATE_ROLES.ZONAL_COUNCIL_OFFICE_HEAD,
    ADVOCATE_ROLES.REGIONAL_COUNCIL_OFFICE_HEAD,
  ]);
  const isRegionalCouncilHead = useHasRole([
    ADVOCATE_ROLES.REGIONAL_COUNCIL_OFFICE_HEAD,
  ]);
  // const canTerminateInspectionLitigation = useHasRole([
  //   ADVOCATE_ROLES.INSPECTION_PROSECUTOR,
  // ]);
  const canAppealToCourt = useHasRole([
    ADVOCATE_ROLES.INSPECTION_REGISTRAR,
    ROLES.INSPECTION_REGISTRAR,
  ]);

  const [isDailyHearingOpen, setIsDailyHearingOpen] = useState(false);
  const [isLitigationDecisionOpen, setIsLitigationDecisionOpen] =
    useState(false);
  const [isCouncilLitigationDecisionOpen, setIsCouncilLitigationDecisionOpen] =
    useState(false);
  const [isTerminateOpen, setIsTerminateOpen] = useState(false);
  const [isAppealCourtOpen, setIsAppealCourtOpen] = useState(false);

  // Accordion state for sidebar sections
  type SectionKey = "evidence" | "reporter" | "victim" | "witness";
  const [accordionOpen, setAccordionOpen] = useState<
    Record<SectionKey, boolean>
  >({
    evidence: false,
    reporter: false,
    victim: false,
    witness: false,
  });

  const toggleSection = (key: SectionKey) =>
    setAccordionOpen((prev) => ({ ...prev, [key]: !prev[key] }));

  const [complaintData, setComplaintData] = useState<
    AdvocateComplaints | AdvocateComplaints[]
  >();
  const [investigationData, setInvestigationData] = useState<Investigation>();
  const [allInvestigationData, setAllInvestigationData] =
    useState<Investigation[]>();
  const [accusedSummonData, setAccusedSummonData] = useState<AccusedSummon>();
  const [
    accusedSummonDataForGeneralCouncil,
    setAccusedSummonDataForGeneralCouncil,
  ] = useState<AccusedSummon>();
  const [appealLitigationData, setAppealLitigationData] =
    useState<Litigation[]>();
  const [
    appealLitigationDataForGenralCouncil,
    setAppealLitigationDataForGeneralCouncil,
  ] = useState<Litigation[]>();
  const [appealCouncilLitigationData, setAppealCouncilLitigationData] =
    useState<CouncilLitigation[]>();
  const [
    appealCouncilLitigationDataForGeneralCouncil,
    setAppealCouncilLitigationDataForGeneralCouncil,
  ] = useState<CouncilLitigation[]>();
  const [courtAppealData, setCourtAppealData] = useState<CourtAppeal>();

  const [
    isCreateAccusedSummonForGeneralCouncil,
    setIsCreateAccusedSummonForGeneralCouncilOpen,
  ] = useState(false);

  const tabs = [
    t("detailInformation"),
    appealCouncilLitigationData && t("councilLitigation"),
    appealCouncilLitigationDataForGeneralCouncil && t("appealToGeneralCouncil"),
    accusedSummonDataForGeneralCouncil?.registration_date &&
      t("generalCouncilLitigation"),
  ].filter((tab): tab is string => Boolean(tab));

  const [activeTab, setActiveTab] = useState<string>(tabs[0]);

  const loadComplaints = useCallback(async () => {
    if (!uu_id) return;
    // setLoading(true);
    try {
      const resData = await fetchAdvocateComplaintById(uu_id);
      setComplaintData(
        Array.isArray(resData) ? resData?.slice()?.reverse()[0] : resData,
      );
      // setError("");
    } catch (err) {
      // setError("Failed to load complaint.");
    } finally {
      // setLoading(false);
    }
  }, [uu_id]);

  const loadInvestigations = useCallback(async () => {
    if (!complaintData || !uu_id) return;
    // setLoading(true);
    try {
      const resData = await fetchInvestigationByComplaintId(uu_id);
      if (resData) {
        setAllInvestigationData(resData?.slice()?.reverse());
        setInvestigationData(
          Array.isArray(resData) ? resData?.slice()?.reverse()[0] : resData,
        );
        // setError("");
      }
    } catch (err) {
      // setError("Failed to load investigation.");
    } finally {
      // setLoading(false);
    }
  }, [complaintData]);

  const loadAccusedSummon = useCallback(async () => {
    if (!complaintData || !uu_id) return;
    // setLoading(true);
    try {
      const resData = await fetchAccusedSummonByComplaintId(uu_id);
      if (resData) {
        const data = resData
          ?.slice()
          ?.reverse()
          ?.filter((obj) => obj.discipline_complain === uu_id);
        setAccusedSummonData(
          data?.filter((obj) => obj.is_appeal_to_general_council === false)[0],
        );
        setAccusedSummonDataForGeneralCouncil(
          data?.filter((obj) => obj.is_appeal_to_general_council === true)[0],
        );
        // setError("");
      }
    } catch (err) {
      // setError("Failed to load investigation.");
    } finally {
      // setLoading(false);
    }
  }, [complaintData]);

  const loadAppealLitigation = useCallback(async () => {
    if (!complaintData || !accusedSummonData) return;
    // setLoading(true);
    try {
      const resData = await fetchAppealLitigationByAppealSummonId(uu_id || "");
      if (resData)
        setAppealLitigationData(
          resData
            ?.slice()
            ?.reverse()
            ?.filter(
              (obj) =>
                obj.summon_appeal_accused_advocate === accusedSummonData?.id,
            ),
        );

      // setError("");
    } catch (err) {
      // setError("Failed to load summon.");
    } finally {
      // setLoading(false);
    }
  }, [complaintData, accusedSummonData]);

  const loadAppealLitigationForGeneralCouncil = useCallback(async () => {
    if (!complaintData || !accusedSummonDataForGeneralCouncil) return;
    // setLoading(true);
    try {
      const resData = await fetchAppealLitigationByAppealSummonId(uu_id || "");
      if (resData)
        setAppealLitigationDataForGeneralCouncil(
          resData
            ?.slice()
            ?.reverse()
            ?.filter(
              (obj: any) =>
                obj.summon_appeal_accused_advocate ===
                accusedSummonDataForGeneralCouncil?.id,
            ),
        );

      // setError("");
    } catch (err) {
      // setError("Failed to load summon.");
    } finally {
      // setLoading(false);
    }
  }, [complaintData, accusedSummonDataForGeneralCouncil]);

  const loadAppealCouncilLitigation = useCallback(async () => {
    if (!accusedSummonData) return;
    // setLoading(true);
    try {
      const resData = await fetchAppealCouncilLitigationByAppealSummonId(
        accusedSummonData?.id || "",
      );
      if (resData)
        setAppealCouncilLitigationData(
          resData
            ?.slice()
            ?.reverse()
            ?.filter(
              (obj) =>
                obj.summon_appeal_accused_advocate === accusedSummonData?.id,
            ),
        );

      // setError("");
    } catch (err) {
      // setError("Failed to load summon.");
    } finally {
      // setLoading(false);
    }
  }, [accusedSummonData]);

  const loadAppealCouncilLitigationForGeneralCouncil = useCallback(async () => {
    if (!accusedSummonData) return;
    // setLoading(true);
    try {
      const resData = await fetchAppealCouncilLitigationByAppealSummonId(
        accusedSummonData?.id || "",
      );
      if (resData)
        setAppealCouncilLitigationDataForGeneralCouncil(
          resData
            ?.slice()
            ?.reverse()
            ?.filter(
              (obj) =>
                obj.summon_appeal_accused_advocate ===
                accusedSummonDataForGeneralCouncil?.id,
            ),
        );
      // setError("");
    } catch (err) {
      // setError("Failed to load summon.");
    } finally {
      // setLoading(false);
    }
  }, [accusedSummonData]);

  const loadCourtAppeal = useCallback(async () => {
    if (!complaintData || !uu_id) return;
    // setLoading(true);
    try {
      const resData = await fetchCourtAppealByComplaintId(uu_id);
      if (resData) {
        setCourtAppealData(
          resData
            ?.slice()
            ?.reverse()
            ?.filter((obj) => obj.discipline_complain === uu_id)[0],
        );
        // setError("");
      }
    } catch (err) {
      // setError("Failed to load investigation.");
    } finally {
      // setLoading(false);
    }
  }, [complaintData]);

  useEffect(() => {
    loadComplaints();
  }, [uu_id]);

  useEffect(() => {
    loadInvestigations();
  }, [complaintData]);

  useEffect(() => {
    loadAccusedSummon();
  }, [complaintData]);

  useEffect(() => {
    loadAppealLitigation();
  }, [complaintData, accusedSummonData]);

  useEffect(() => {
    loadAppealLitigationForGeneralCouncil();
  }, [complaintData, accusedSummonDataForGeneralCouncil]);

  useEffect(() => {
    loadAppealCouncilLitigation();
  }, [complaintData, accusedSummonData]);

  useEffect(() => {
    loadAppealCouncilLitigationForGeneralCouncil();
  }, [complaintData, accusedSummonDataForGeneralCouncil]);

  useEffect(() => {
    loadCourtAppeal();
  }, [complaintData]);

  console.log(
    "appealLitigationDataForGenralCouncil",
    appealLitigationDataForGenralCouncil,
  );
  console.log(
    "appealCouncilLitigationDataForGeneralCouncil",
    appealCouncilLitigationDataForGeneralCouncil,
  );

  return (
    <div className="min-h-screen">
      <h1 className="text-2xl font-semibold text-gray-700 flex items-center gap-2 mb-5">
        <span>💼</span>
        {t("accused")}{" "}
        {complaintData && Array.isArray(complaintData)
          ? ""
          : complaintData?.is_on_advocate_complaint
            ? t("advocate")
            : t("paralegal")}{" "}
        {t("complaintDetail")}
      </h1>

      <div className="w-full flex flex-wrap items-center justify-between gap-4 mb-5">
        <TabNav active={activeTab} tabs={tabs} onSelect={setActiveTab} />

        {activeTab === tabs[1] && (
          <div className="flex gap-4">
            {accusedSummonData?.status === ACCUSED_COMPLAINT_STATUS.APPROVED &&
              ((canCreateInspectionDailyHearing &&
                (!appealLitigationData ||
                  (appealLitigationData &&
                    !appealLitigationData[0]?.is_final_verdict_given))) ||
                (canCreateCouncilDailyHearingForWritter &&
                  (!appealCouncilLitigationData ||
                    (appealCouncilLitigationData &&
                      !appealCouncilLitigationData[0]
                        ?.is_final_verdict_given)))) && (
                <button
                  className="bg-red-700 text-white px-8 py-2 rounded-md hover:bg-gray-800"
                  type="submit"
                  onClick={() => setIsDailyHearingOpen(true)}
                >
                  {canCreateCouncilDailyHearingForWritter &&
                  appealCouncilLitigationData?.length === 0
                    ? t("addInitialHearing")
                    : t("addDailyHearing")}
                </button>
              )}

            {canCreateLitigationDecision &&
              appealLitigationData &&
              appealLitigationData[0]?.is_final_verdict_given &&
              !appealLitigationData[0]?.council_decision_summary &&
              !appealLitigationData[0]?.council_decision && (
                // councilLitigationData &&
                // councilLitigationData[0]?.is_final_verdict_given &&
                // (councilLitigationData[0]?.council_decision_summary ||
                //   councilLitigationData[0]?.council_decision) &&
                <button
                  className="bg-red-700 text-white px-8 py-2 rounded-md hover:bg-gray-800"
                  type="submit"
                  onClick={() => setIsLitigationDecisionOpen(true)}
                >
                  {t("addAppealLitigationDecision")}
                </button>
              )}

            {canCreateCouncilDailyHearingForWritter &&
              appealCouncilLitigationData &&
              appealCouncilLitigationData[0]?.is_final_verdict_given &&
              !appealCouncilLitigationData[0]?.council_decision_summary &&
              !appealCouncilLitigationData[0]?.council_decision && (
                <button
                  className="bg-red-700 text-white px-8 py-2 rounded-md hover:bg-gray-800"
                  type="submit"
                  onClick={() => setIsCouncilLitigationDecisionOpen(true)}
                >
                  {t("addCouncilOfficeDecision")}
                </button>
              )}

            {canAppealToCourt &&
              !accusedSummonDataForGeneralCouncil &&
              appealCouncilLitigationData &&
              appealCouncilLitigationData[0]?.is_final_verdict_given &&
              (appealCouncilLitigationData[0]?.council_decision_summary ||
                appealCouncilLitigationData[0]?.council_decision) && (
                <button
                  className="bg-red-700 text-white px-8 py-2 rounded-md hover:bg-gray-800"
                  type="submit"
                  onClick={() =>
                    setIsCreateAccusedSummonForGeneralCouncilOpen(true)
                  }
                >
                  {t("appealToGeneralCouncil")}
                </button>
              )}

            {/* {canAppealToCourt &&
              !courtAppealData &&
              appealCouncilLitigationData &&
              appealCouncilLitigationData[0]?.is_final_verdict_given &&
              (appealCouncilLitigationData[0]?.council_decision_summary ||
                appealCouncilLitigationData[0]?.council_decision) && (
                <button
                  className="bg-red-700 text-white px-8 py-2 rounded-md hover:bg-gray-800"
                  type="submit"
                  onClick={() => setIsAppealCourtOpen(true)}
                >
                  Appeal to Court
                </button>
              )} */}
          </div>
        )}

        {activeTab === tabs[3] && (
          <div className="flex gap-4">
            {
              // accusedSummonData?.status === ACCUSED_COMPLAINT_STATUS.APPROVED &&
              //   accusedSummonData?.registration_number &&

              ((canCreateInspectionDailyHearing &&
                (!appealLitigationDataForGenralCouncil ||
                  (appealLitigationDataForGenralCouncil &&
                    !appealLitigationDataForGenralCouncil[0]
                      ?.is_final_verdict_given))) ||
                (isRegionalCouncilHead &&
                  (!appealCouncilLitigationDataForGeneralCouncil ||
                    (appealCouncilLitigationDataForGeneralCouncil &&
                      !appealCouncilLitigationDataForGeneralCouncil[0]
                        ?.is_final_verdict_given)))) && (
                <button
                  className="bg-red-700 text-white px-8 py-2 rounded-md hover:bg-gray-800"
                  type="submit"
                  onClick={() => setIsDailyHearingOpen(true)}
                >
                  {isRegionalCouncilHead &&
                  appealCouncilLitigationDataForGeneralCouncil?.length === 0
                    ? t("addInitialHearing")
                    : t("addDailyHearing")}
                </button>
              )
            }

            {canCreateInspectionDailyHearing &&
              appealLitigationDataForGenralCouncil &&
              appealLitigationDataForGenralCouncil[0]?.is_final_verdict_given &&
              !appealLitigationDataForGenralCouncil[0]
                ?.council_decision_summary &&
              !appealLitigationDataForGenralCouncil[0]?.council_decision && (
                // councilLitigationData &&
                // councilLitigationData[0]?.is_final_verdict_given &&
                // (councilLitigationData[0]?.council_decision_summary ||
                //   councilLitigationData[0]?.council_decision) &&
                <button
                  className="bg-red-700 text-white px-8 py-2 rounded-md hover:bg-gray-800"
                  type="submit"
                  onClick={() => setIsLitigationDecisionOpen(true)}
                >
                  {t("addAppealLitigationDecision")}
                </button>
              )}

            {isRegionalCouncilHead &&
              appealCouncilLitigationDataForGeneralCouncil &&
              appealCouncilLitigationDataForGeneralCouncil[0]
                ?.is_final_verdict_given &&
              !appealCouncilLitigationDataForGeneralCouncil[0]
                ?.council_decision_summary &&
              !appealCouncilLitigationDataForGeneralCouncil[0]
                ?.council_decision && (
                <button
                  className="bg-red-700 text-white px-8 py-2 rounded-md hover:bg-gray-800"
                  type="submit"
                  onClick={() => setIsCouncilLitigationDecisionOpen(true)}
                >
                  {t("addCouncilOfficeDecision")}
                </button>
              )}

            {canAppealToCourt &&
              !courtAppealData &&
              appealCouncilLitigationDataForGeneralCouncil &&
              appealCouncilLitigationDataForGeneralCouncil[0]
                ?.is_final_verdict_given &&
              (appealCouncilLitigationDataForGeneralCouncil[0]
                ?.council_decision_summary ||
                appealCouncilLitigationDataForGeneralCouncil[0]
                  ?.council_decision) && (
                <button
                  className="bg-red-700 text-white px-8 py-2 rounded-md hover:bg-gray-800"
                  type="submit"
                  onClick={() => setIsAppealCourtOpen(true)}
                >
                  {t("appealToCourt")}
                </button>
              )}
          </div>
        )}
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
        {/* Detail Info */}
        {activeTab === tabs[0] && (
          <div className="lg:col-span-2 space-y-4">
            {canViewAccusedSummon &&
              accusedSummonData &&
              complaintData &&
              !Array.isArray(complaintData) && (
                <AccusedSummonCard
                  compliantData={complaintData}
                  summonData={accusedSummonData}
                  appealLitigationData={appealLitigationData}
                  onSummonRefresh={loadAccusedSummon}
                  onComplaintsRefresh={loadComplaints}
                />
              )}

            {investigationData &&
              complaintData &&
              !Array.isArray(complaintData) &&
              (canViewChargeDoc ||
                investigationData?.status ===
                  INVESTIGATION_STATUS.FORWARDED_TO_COUNCIL ||
                investigationData?.status ===
                  INVESTIGATION_STATUS.FORWARDED_TO_HEAD) && (
                <ChargeDocumentCard
                  investigationData={investigationData}
                  complaintData={complaintData}
                  onInvestigationRefresh={loadInvestigations}
                />
              )}

            {canViewCompliantDetail &&
              complaintData &&
              investigationData &&
              allInvestigationData &&
              !Array.isArray(complaintData) &&
              complaintData.status !== COMPLIANT_STATUS?.PENDING && (
                <DecisionCard
                  complaintData={complaintData}
                  investigationData={investigationData}
                  allInvestigationData={allInvestigationData}
                  onInvestigationRefresh={loadInvestigations}
                />
              )}

            {canViewCompliantDetail && (
              <ComplaintDetailInfoCard
                complaintData={complaintData}
                onComplaintsRefresh={loadComplaints}
              />
            )}
          </div>
        )}

        {/* Litigation */}
        {activeTab === tabs[1] && (
          <div className="lg:col-span-2 space-y-4">
            {appealCouncilLitigationData &&
              appealCouncilLitigationData?.length > 0 && (
                <AppealCouncilLitigationCard
                  councilLitigationData={appealCouncilLitigationData}
                  onCouncilLitigationRefresh={loadAppealCouncilLitigation}
                />
              )}

            {canViewAppealLitigationCard &&
              appealLitigationData &&
              appealLitigationData?.length > 0 && (
                <AppealLitigationCard
                  litigationData={appealLitigationData}
                  councilLitigationData={appealCouncilLitigationData || []}
                  onLitigationRefresh={loadAppealLitigation}
                />
              )}
          </div>
        )}

        {/* Litigation */}
        {activeTab === tabs[2] && (
          <div className="lg:col-span-2 space-y-4">
            {canViewAccusedSummon &&
              accusedSummonDataForGeneralCouncil &&
              complaintData &&
              !Array.isArray(complaintData) && (
                <AccusedSummonCard
                  compliantData={complaintData}
                  summonData={accusedSummonDataForGeneralCouncil}
                  onSummonRefresh={loadAccusedSummon}
                  onComplaintsRefresh={loadComplaints}
                  isAppealToGeneralCouncil={true}
                />
              )}
          </div>
        )}

        {/* Litigation */}
        {activeTab === tabs[3] && (
          <div className="lg:col-span-2 space-y-4">
            {appealCouncilLitigationDataForGeneralCouncil &&
              appealCouncilLitigationDataForGeneralCouncil?.length > 0 && (
                <AppealCouncilLitigationCard
                  councilLitigationData={
                    appealCouncilLitigationDataForGeneralCouncil
                  }
                  onCouncilLitigationRefresh={loadAppealCouncilLitigation}
                />
              )}

            {appealLitigationDataForGenralCouncil &&
              appealLitigationDataForGenralCouncil?.length > 0 && (
                <AppealLitigationCard
                  litigationData={appealLitigationDataForGenralCouncil}
                  councilLitigationData={
                    appealCouncilLitigationDataForGeneralCouncil || []
                  }
                  onLitigationRefresh={loadAppealLitigation}
                />
              )}
          </div>
        )}

        {/* Sidebar */}
        <div className="space-y-4">
          {canViewCompliantDetail && (
            <>
              {/* Evidence List Card with Accordion */}
              <div className="bg-white rounded-lg shadow-sm border border-gray-200">
                <button
                  onClick={() => toggleSection("evidence")}
                  className="w-full px-4 py-3 text-left bg-gray-50 hover:bg-gray-100 transition-colors border-b border-gray-200 flex justify-between items-center"
                >
                  <span className="font-medium text-gray-900">
                    {t("evidence")}
                  </span>
                  <svg
                    className={`w-5 h-5 text-gray-500 transition-transform duration-200 ${
                      accordionOpen.evidence ? "rotate-180" : ""
                    }`}
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M19 9l-7 7-7-7"
                    />
                  </svg>
                </button>
                <div
                  className={`overflow-hidden transition-all duration-300 ease-in-out ${
                    accordionOpen.evidence
                      ? "max-h-[1000px] opacity-100"
                      : "max-h-0 opacity-0"
                  }`}
                >
                  <div className="p-4">
                    <ListEvidenceCard
                      complaintData={complaintData}
                      onComplaintsRefresh={loadComplaints}
                    />
                  </div>
                </div>
              </div>

              {/* Reporter List Card with Accordion */}
              <div className="bg-white rounded-lg shadow-sm border border-gray-200">
                <button
                  onClick={() => toggleSection("reporter")}
                  className="w-full px-4 py-3 text-left bg-gray-50 hover:bg-gray-100 transition-colors border-b border-gray-200 flex justify-between items-center"
                >
                  <span className="font-medium text-gray-900">
                    {t("reporter")}
                  </span>
                  <svg
                    className={`w-5 h-5 text-gray-500 transition-transform duration-200 ${
                      accordionOpen.reporter ? "rotate-180" : ""
                    }`}
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M19 9l-7 7-7-7"
                    />
                  </svg>
                </button>
                <div
                  className={`overflow-hidden transition-all duration-300 ease-in-out ${
                    accordionOpen.reporter
                      ? "max-h-[1000px] opacity-100"
                      : "max-h-0 opacity-0"
                  }`}
                >
                  <div className="p-4">
                    <ListReporterCard
                      complaintData={complaintData}
                      onComplaintsRefresh={loadComplaints}
                    />
                  </div>
                </div>
              </div>

              {/* Victim List Card with Accordion */}
              <div className="bg-white rounded-lg shadow-sm border border-gray-200">
                <button
                  onClick={() => toggleSection("victim")}
                  className="w-full px-4 py-3 text-left bg-gray-50 hover:bg-gray-100 transition-colors border-b border-gray-200 flex justify-between items-center"
                >
                  <span className="font-medium text-gray-900">
                    {t("victim")}
                  </span>
                  <svg
                    className={`w-5 h-5 text-gray-500 transition-transform duration-200 ${
                      accordionOpen.victim ? "rotate-180" : ""
                    }`}
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M19 9l-7 7-7-7"
                    />
                  </svg>
                </button>
                <div
                  className={`overflow-hidden transition-all duration-300 ease-in-out ${
                    accordionOpen.victim
                      ? "max-h-[1000px] opacity-100"
                      : "max-h-0 opacity-0"
                  }`}
                >
                  <div className="p-4">
                    <ListVictimCard
                      complaintData={complaintData}
                      onComplaintsRefresh={loadComplaints}
                    />
                  </div>
                </div>
              </div>

              {/* Witness List Card with Accordion */}
              <div className="bg-white rounded-lg shadow-sm border border-gray-200">
                <button
                  onClick={() => toggleSection("witness")}
                  className="w-full px-4 py-3 text-left bg-gray-50 hover:bg-gray-100 transition-colors border-b border-gray-200 flex justify-between items-center"
                >
                  <span className="font-medium text-gray-900">
                    {t("witness")}
                  </span>
                  <svg
                    className={`w-5 h-5 text-gray-500 transition-transform duration-200 ${
                      accordionOpen.witness ? "rotate-180" : ""
                    }`}
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M19 9l-7 7-7-7"
                    />
                  </svg>
                </button>
                <div
                  className={`overflow-hidden transition-all duration-300 ease-in-out ${
                    accordionOpen.witness
                      ? "max-h-[1000px] opacity-100"
                      : "max-h-0 opacity-0"
                  }`}
                >
                  <div className="p-4">
                    <ListWitnessCard
                      complaintData={complaintData}
                      onComplaintsRefresh={loadComplaints}
                    />
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      </div>

      {/* /////////////////// MODAL FORMS ///////////////////  */}
      {complaintData && !Array.isArray(complaintData) && (
        <AddAccusedDailyHearingModal
          isOpen={isDailyHearingOpen}
          setIsOpen={setIsDailyHearingOpen}
          summonData={
            (activeTab === tabs[1]
              ? accusedSummonData && accusedSummonData
              : accusedSummonDataForGeneralCouncil &&
                accusedSummonDataForGeneralCouncil) as AccusedSummon
          }
          complaintData={complaintData}
          onLitigationRefresh={loadAppealLitigation}
          onCouncilLitigationRefresh={loadAppealCouncilLitigation}
          isAppealToGeneralCouncil={activeTab === tabs[3] ? true : false}
        />
      )}

      {appealLitigationData &&
        complaintData &&
        !Array.isArray(complaintData) && (
          <AddAppealLitigationDecisionModal
            isOpen={isLitigationDecisionOpen}
            setIsOpen={setIsLitigationDecisionOpen}
            complaintData={complaintData}
            litigationData={
              (activeTab === tabs[1]
                ? appealLitigationData && appealLitigationData[0]
                : appealLitigationDataForGenralCouncil &&
                  appealLitigationDataForGenralCouncil[0]) as Litigation
            }
            onRefresh={loadAppealLitigation}
          />
        )}

      {appealLitigationData &&
        complaintData &&
        !Array.isArray(complaintData) && (
          <AddAccusedSummonModal
            isOpen={isCreateAccusedSummonForGeneralCouncil}
            setIsOpen={setIsCreateAccusedSummonForGeneralCouncilOpen}
            complaintData={complaintData}
            onComplaintRefresh={loadComplaints}
            isAppealToGeneralCouncil={true}
          />
        )}

      {appealCouncilLitigationData &&
        complaintData &&
        !Array.isArray(complaintData) && (
          <AddAppealCouncilLitigationDecisionModal
            isOpen={isCouncilLitigationDecisionOpen}
            setIsOpen={setIsCouncilLitigationDecisionOpen}
            complaintData={complaintData}
            councilLitigationData={
              (activeTab === tabs[1]
                ? appealCouncilLitigationData && appealCouncilLitigationData[0]
                : appealCouncilLitigationDataForGeneralCouncil &&
                  appealCouncilLitigationDataForGeneralCouncil[0]) as CouncilLitigation
            }
            onRefresh={loadAppealCouncilLitigation}
          />
        )}

      {complaintData &&
        !Array.isArray(complaintData) &&
        appealLitigationData && (
          <TerminateAppealLitigationModal
            isOpen={isTerminateOpen}
            setIsOpen={setIsTerminateOpen}
            litigationData={appealLitigationData[0]}
            complaintData={complaintData}
            onRefresh={loadAppealLitigation}
          />
        )}

      {appealCouncilLitigationData &&
        complaintData &&
        !Array.isArray(complaintData) && (
          <AppealToCourtModal
            isOpen={isAppealCourtOpen}
            setIsOpen={setIsAppealCourtOpen}
            complaintData={complaintData}
            onComplaintRefresh={loadComplaints}
          />
        )}
    </div>
  );
}
